// components
import { styled, Box, lighten, Button, BoxProps } from '@mui/material';

// constants
import { TIMELINE_SUMMARY_WIDTH } from '../TimelineRoute/Summary/Summary';
import { TASK_LIST_WIDTH } from 'components/shared/TaskList';

export const TimelineBarContainer = styled(Box)(() => ({
  position: 'sticky',
  zIndex: 40,
  top: 0,
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  height: '48px'
}));

export const TimelineContainer = styled(Box)(() => ({
  position: 'absolute',
  zIndex: 42,
  top: '12px',
  left: `${TIMELINE_SUMMARY_WIDTH}px`,
  height: '100%',
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  pointerEvents: 'none',
  userSelect: 'none'
}));

export const ZoomButtonsContainer = styled(Box)(({ theme }) => ({
  position: 'fixed',
  zIndex: 43,
  display: 'flex',
  gap: theme.spacing(1),
  marginRight: theme.spacing(2),
  marginTop: theme.spacing(1.5),
  borderRadius: theme.spacing(0.5),
  padding: theme.spacing(4, 8, 4, 0),
  backgroundColor: theme.palette.background.default,
  boxShadow: `0 16px 16px 12px ${theme.palette.background.default}`
}));

export const ActionButtonsContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isTaskListOpen'
})<BoxProps & { isTaskListOpen?: boolean }>(({ theme, isTaskListOpen }) => ({
  position: 'fixed',
  zIndex: 43,
  width: isTaskListOpen
    ? `calc(100% - ${
        TIMELINE_SUMMARY_WIDTH + TASK_LIST_WIDTH + 110 // 110 = margin-left of ActionsButtonsContainer
      }px)`
    : `calc(100% - ${TIMELINE_SUMMARY_WIDTH + 130}px)`,
  marginLeft: `${TIMELINE_SUMMARY_WIDTH - 40}px`,
  marginTop: theme.spacing(1.5),
  display: 'flex',
  justifyContent: 'space-between',
  borderRadius: theme.spacing(0.5)
}));

export const ActionButton = styled(Button)(({ theme }) => ({
  position: 'relative',
  zIndex: 40,

  minWidth: 'initial',
  width: '25px',
  height: '25px',
  padding: theme.spacing(1),
  boxSizing: 'border-box',

  border: 'none',
  outline: 'none',
  borderRadius: theme.spacing(1),
  fontSize: '12px',

  '&:disabled:not(:hover)': {
    border: 'none',
    background: 'initial',

    '& svg': {
      color: lighten(theme.palette.common.black, 0.5)
    }
  }
}));

export const TimelineGrayBackgroundBox = styled(Box)(({ theme }) => ({
  position: 'fixed',
  zIndex: 0,
  left: 0,
  right: 0,
  marginTop: 0,
  height: '48px',
  backgroundColor: theme.palette.background.default,
  boxShadow: `0 0 16px 12px ${theme.palette.background.default}`
}));
